import {Component, OnDestroy, OnInit} from '@angular/core';
import {InitiateResponseCard} from "../../../../interfaces/card/responses/InitiateResponseCard";
import {Session} from "../../../../interfaces/session-data";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {CardService} from "../../../../services/card/card.service";
import {AuthoriseResponseCard} from "../../../../interfaces/card/responses/AuthoriseResponseCard";
import {HttpErrorResponse} from "@angular/common/http";
import {SessionService} from "../../../../services/session/session.service";
import { TransactionStatus } from 'src/app/interfaces/transaction/TransactionStatus';
import {TransactionService} from "../../../../services/transaction/transaction.service";
import {filter} from "rxjs/operators";
import {Location} from "@angular/common";
import {CardSchema} from "../../../../interfaces/card/CardSchema";
import {GooglePayService} from "../../../../services/google-pay.service";
import {Subscription} from "rxjs";
import { ChargeAmount } from 'src/app/interfaces/SessionDisplayInformation';
import cloneDeep from 'lodash/cloneDeep';


@Component({
  selector: 'app-google-pay-selected',
  templateUrl: './google-pay-selected.component.html',
  styleUrls: ['./google-pay-selected.component.scss']
})
export class GooglePaySelectedComponent implements OnInit, OnDestroy {
  public link: string;
  initiateResponseCard: InitiateResponseCard;
  navigated: boolean;
  sessionData: Session;

  public formSubmitted: boolean = false;
  public iframeLoaded: boolean;
  public iframePostback: boolean;
  public paymentCancelled: boolean = false;
  private isMobile: boolean;
  private boundHandleIframeLoad: any;

  private charge:ChargeAmount;

  constructor(
    private router: Router,
    private sessionService: SessionService,
    private route: ActivatedRoute,
    private cardService: CardService,
    private transactionService: TransactionService,
    private location: Location,
    private googlePayService: GooglePayService,
    // public iframeService: IframeService
  ) {
    this.boundHandleIframeLoad = this.handleIframeLoad.bind(this);
    this.link = "card/google-pay";
  }

  private client: google.payments.api.PaymentsClient;
  initiateRequestCard: google.payments.api.PaymentData;
  paymentData: google.payments.api.PaymentData | null;
  private paymentDataSubscription: Subscription;

  ngOnInit(): void {
    // this.selectMethod();
    this.iframeLoaded = false;
    this.iframePostback = false;
    this.formSubmitted = false;
    window.addEventListener('message', this.boundHandleIframeLoad, false);
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.makePayment().then(() => {
      this.paymentDataSubscription = this.googlePayService.getPaymentData().subscribe(
        (data) => {
          if (data) {
            this.paymentData = data;
            // const paymentResponse = this.client
          }
        }
      );
    });
    this.sessionService.getSelectedChargeAmount().subscribe((val)=>this.charge=val);
  }

  async makePayment() {
    try {
      this.formSubmitted = true;
      const client = await this.googlePayService.initializeGooglePay();
      const paymentData = await this.googlePayService.loadPaymentData(client);

      const result = await this.onPaymentAuthorized(paymentData);

      if (result.transactionState === 'SUCCESS') {
        // Only navigate if 3DS was not required (for 3DS, navigation happens after iframe completion)
        if (!result.threeDSecureRequired) {
          this.navigateToStatus();
        }
        // Handle successful payment (e.g., show success message, navigate to confirmation page)
      } else {
        console.error('Payment authorization failed', result.error);
        this.navigateToStatus();
        // Handle failed payment (e.g., show error message)
      }
    } catch (error) {
      console.error('Error:', error);
      this.paymentCancelled = true;
      // Handle error (e.g., show error message to user)
    }
  }

  private onPaymentAuthorized(paymentData: google.payments.api.PaymentData): Promise<{transactionState: string, error?: any, threeDSecureRequired?: boolean}> {
    return new Promise((resolve, reject) => {
      this.initiateRequestCard = paymentData;
      let payment = cloneDeep(paymentData);
      payment.authoriseCurrencyCode = this.sessionData.sessionDisplayInformation.currencyCode != this.charge.currency ? this.charge.currency : undefined;
      payment.authoriseAmount = this.sessionData.sessionDisplayInformation.currencyCode != this.charge.currency ? this.charge.amount : undefined;

      this.sessionService.emitPaymentMethodListLock(true);

      this.cardService.initiateGooglePayTransaction(this.initiateRequestCard, sessionStorage.getItem('sessionToken')).subscribe(
        (data: InitiateResponseCard) => {
          this.initiateResponseCard = data;
          this.navigated = true;

          if (this.initiateResponseCard.threeDSecureAuthRequired) {
            // Redirect User for 3D Secure
            sessionStorage.setItem('acs-form', JSON.stringify(this.initiateResponseCard));
            setTimeout(() => {
              const acsForm = (document.getElementById('acs-form') as HTMLFormElement);
              acsForm.submit();
            }, 750);
            resolve({transactionState: 'SUCCESS', threeDSecureRequired: true}); // Assuming 3D Secure redirect is considered successful
          } else {
            this.cardService.authoriseTransaction(sessionStorage.getItem('sessionToken')).subscribe(
              (dataAuthorise: AuthoriseResponseCard) => {
                resolve({transactionState: 'SUCCESS', threeDSecureRequired: false});
                // this.navigateToStatus();
              },
              (err) => {
                resolve({
                  transactionState: 'ERROR',
                  threeDSecureRequired: false,
                  error: {
                    intent: 'PAYMENT_AUTHORIZATION',
                    message: 'Authorization failed',
                    reason: 'PAYMENT_DATA_INVALID'
                  }
                });
                // this.navigateToStatus();
              }
            );
          }
        },
        (err: HttpErrorResponse) => {
          resolve({
            transactionState: 'ERROR',
            threeDSecureRequired: false,
            error: {
              intent: 'PAYMENT_AUTHORIZATION',
              message: 'Transaction initiation failed',
              reason: 'PAYMENT_DATA_INVALID'
            }
          });
          // this.navigateToStatus();
        }
      );
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.boundHandleIframeLoad);
  }
  // toggleListView(){
  //   this.sessionService.emitPaymentMethodPromotion("google-pay");
  // }

  // selectMethod(event?: Event){
  //   sessionStorage.setItem("selected-payment","google_pay");
  //   if(event!=unde+fined){
  //     this.sessionService.emitSelectedPaymentMethod("google-pay");
  //     this.router.navigate([this.link],{relativeTo: this.route});
  //     this.initializePaymentRequest();
  //     this.makePayment();
  //     // this.iframeService.setFormSubmitted(true);
  //     // this.iframeSrc = "";
  //   }
  // }
  extractCodes(cards: CardSchema[]): string[] {
    return cards.map(card => card.code.toUpperCase());
  }

  public reInitiateGooglePay(): void {
    if(this.paymentCancelled){
      // this.initializePaymentRequest();
      // this.makePayment();
      this.paymentCancelled = false;
    }
  }

  generateDisplayItems(): { label: string; amount: { currency: string; value: string } }[] {
    return this.sessionData.orderItems.map(item => ({
      label: `${item.itemName} (x ${item.quantity})`,
      amount: { currency: this.sessionData.sessionDisplayInformation.currencyCode, value: item.amount }
    }));
  }

  getColorScheme(): string {
    if (this.sessionData && this.sessionData.sessionDisplayInformation && this.sessionData.sessionDisplayInformation.colorScheme) {
      return this.sessionData.sessionDisplayInformation.colorScheme.replace(';', '');
    }
    return 'inherit';
  }

  getTextColor(): string {
    if (this.sessionData && this.sessionData.sessionDisplayInformation && this.sessionData.sessionDisplayInformation.colorScheme) {
      let bgColor:string = this.sessionData.sessionDisplayInformation.colorScheme.replace(';', '');
      let color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      let r = parseInt(color.substring(0, 2), 16); // Red
      let g = parseInt(color.substring(2, 4), 16); // Green
      let b = parseInt(color.substring(4, 6), 16); // Blue

      // Calculate the perceptive luminance
      let luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

      // Return black for bright colors, white for dark colors
      return luminance > 0.5 ? '#000000' : '#FFFFFF';
    }
    return 'inherit';
  }

  iframeOnLoad(event:any){
    if(!this.iframePostback){
      this.iframeLoaded = true;
    }
  }

  tdsAuthed;
  pollingInterval;
  loading;
  private handleIframeLoad(event: MessageEvent) {
    // Check if the message is from the expected origin
    if(!/^https:\/\/(?:[a-zA-Z0-9-]+\.)*adumoonline\.com(\/|$)/.test(event.origin)) return;

    // Handle the response from the iframe
    if (event.data.status === 'COMPLETED' && event.data.paymethod==='CARD') {
      // Redirect the parent window
      sessionStorage.removeItem('acs-form');
      this.iframeLoaded = false;
      this.iframePostback = true;
      this.transactionService.getTransactionStatusCard(sessionStorage.getItem('sessionToken'))
        .subscribe((data: TransactionStatus) => {
            if (data?.transactionState === 'TDS_AUTHENTICATED') {
              this.tdsAuthed = true;
              this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
              if (this.sessionData.flow !== 'CARD_VERIFICATION') {
                this.authoriseCard();
              } else {
                this.navigateToStatus();
              }
            } else {
              this.navigateToStatus();
            }
          }, (error: HttpErrorResponse) => {
            this.navigateToStatus();
          }
        );
    }
  }
  private authoriseCard() {
    this.sessionService.emitPaymentMethodListLock(true);
    this.cardService.authoriseTransaction(sessionStorage.getItem('sessionToken')).subscribe((dataAuthorise: AuthoriseResponseCard) => {
      this.navigateToStatus();
    }, (err) => {
      if (err.status === 409) {
        const timeout = 300;
        const inteval = 5;
        let count = 0;
        setTimeout(() => {
          this.clearIntervalCustom(this.pollingInterval);
        }, timeout * 1000);
        this.pollingInterval = setInterval(() => {
          count++;
          this.transactionService.getTransactionStatusCard(sessionStorage.getItem('sessionToken'))
            .subscribe((data: TransactionStatus) => {
              if (data.transactionState === 'SETTLED') {
                this.navigateToStatus();
              }
            });
        }, inteval * 1000);
      } else {
        this.navigateToStatus();
      }
    });
  }

  navigateToStatus() {
    this.loading = false;

    // Subscribe to router events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Remove the previous route from history
      this.location.replaceState('/transaction-status');
    });

    this.router.navigate(
      [`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`],
      {
        replaceUrl: true // This replaces the current history entry
      });
  }
  private clearIntervalCustom(interval) {
    clearInterval(interval);
    this.navigateToStatus();
  }
}
